import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {OilData} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-edit-oil',
    templateUrl: './edit-oil.component.html',
    styleUrls: ['./edit-oil.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditOilComponent {
  @Input() oil: OilData;
}
